const primaryFontFamily = 'Roboto';
const primaryColor = 'rgba(24, 23, 26, 1)';
const secondaryColor = 'rgba(0, 0, 0, 1)';
const backgroundColor = 'rgb(255, 255, 255)';
const borderColor = 'rgba(208, 208, 208, 1)';

export default {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  text: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: primaryFontFamily,
    color: backgroundColor,
    borderColor: secondaryColor,
    backgroundColor: primaryColor,
  },
  rank: {
    fontFamily: primaryFontFamily,
    baseColor: borderColor,
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
  },
  social: {
    color: secondaryColor,
  },
  survey: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
    backgroundColor: 'rgb(232, 232, 232)',
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    secondaryBackgroundColor: 'rgb(232, 232, 232)',
  },
  voucher: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
  },
  checkbox: {
    color: primaryColor,
    borderColor: borderColor,
    checkboxColor: primaryColor,
    backgroundColor: backgroundColor,
  },
};